import React, { useState } from 'react';
import axios from 'axios';
import Calendar from 'react-calendar';
import Select from 'react-select';
import ClipLoader from 'react-spinners/ClipLoader';
import 'react-calendar/dist/Calendar.css';
import { FaInfoCircle } from "react-icons/fa";
import { getMinMaxDates, formatValue } from '../utils/format';
import * as XLSX from 'xlsx';
import "../styles/ConsumptionReport.css"


export const capitalizeWords = (str) => {
  return str
    .replace(/_/g, ' ')
    .split(' ')
    .map(
      w =>
        w.charAt(0).toUpperCase() +
        w.slice(1).toLowerCase()
    )
    .join(' ');
};

export const tileDisabledHelper = (
  date,
  view,
  storedDates,
  format,
  isAvailable
) => {
  if (view !== "month") return false;

  const available = isAvailable(date);
  return !available;
};

const ConsumptionReport = ({
  title,
  storageKey,
  excelConfig,
  apiPayloadBuilder,
  outlets
}) => {

  const storedRaw = JSON.parse(localStorage.getItem(storageKey) || '[]');
  const storedDates = Array.isArray(storedRaw)
    ? storedRaw
    : Array.isArray(storedRaw?.success)
      ? storedRaw.success
      : [];
  const { minDate, maxDate } = getMinMaxDates(storedDates);
  console.log("minDate", minDate);
  console.log("maxDate", maxDate);

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDates, setSelectedDates] = useState(null);
  const [loading, setLoading] = useState(false);

  const reportType = [
    { value: 'daily', label: 'Daily'},
    // { value: 'weekly', label: 'Weekly'},
    // { value: 'monthly', label: 'Monthly'},
    { value: 'customize', label: 'Customize'}
  ];

  const [selectedReport, setSelectedReport] = useState(reportType[0]);

  // Info Message
  const getReportInfoMessage = () => {
    switch (selectedReport.value) {
      case "daily": 
        return "Select a specific available date.";
      case "customize": 
        return "Select a date range.";
    }
  };

  // Date Helpers
  const format = (d) =>
    new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];

  const isAvailable = (date) => {
    const f = format(date);
    return storedDates.includes(f);
  };

  // const isWeekend = (date) => date.getDay() === 6;

  // const getMaxAvailableDateOfMonth = (date) => {
  //   const year = date.getFullYear();
  //   const month = date.getMonth();

  //   const dates = storedDates
  //     .map(d => new Date(d))
  //     .filter(d => d.getFullYear() === year && d.getMonth() === month);

  //   return dates.length ? new Date(Math.max(...dates)) : null;
  // };

  // Calendar Disable Logic
  const tileDisabled = ({ date, view }) => {
    return tileDisabledHelper(
      date,
      view,
      storedDates,
      format,
      isAvailable
    );
  };

  // Excel Generator
  const writeToExcel = (responseData, start_date, end_date) => {
    if (!Array.isArray(responseData) || responseData.length === 0) {
        alert("Consumption is not calculated for the specified date");
        return;
    }

    let headers;
    let rows;

    // Headers from config
    headers = excelConfig.getHeaders(responseData, selectedReport.value, capitalizeWords);

    // Rows from config
    rows = responseData.map(item =>
        excelConfig.mapRow(item, selectedReport.value, formatValue)
    );

    const data = [headers, ...rows];
    const filename =
        selectedReport.value === 'daily'
        ? `${title} ${selectedReport.label} Report For ${start_date}.xlsx`
        : `${title} ${selectedReport.label} Report From ${start_date} To ${end_date}.xlsx`;
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, filename);
  };

  // Fetch
  const fetchReport = async () => {
    let start_date, end_date;

    if (selectedReport.value === "customize") {
      const [s, e] = selectedDates;
      start_date = format(s);
      end_date = format(e);
    } else {
      const formattedDate = new Date(selectedDate);
      const format = (d) =>
        new Date(d.getTime() - d.getTimezoneOffset() * 60000)
          .toISOString()
          .split("T")[0];
      start_date = format(formattedDate);
      end_date = format(formattedDate);
    }

    setLoading(true);
    try {
      const payload = apiPayloadBuilder({
        start_date,
        end_date,
        outlets
      });

      const res = await axios.post(
        `/api/get_consumption_data`,
        payload
      );

      let data = res.data;

      if (data && typeof data.data === "string") {
        data = JSON.parse(data.data);
        writeToExcel(data, start_date, end_date);
      } else {
        alert("No data");
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  };

  const checkForDateandReportType = () => {
    if (selectedReport.value === "customize") {
      // Require a proper [start, end] array
      if (
        !Array.isArray(selectedDates) ||
        selectedDates.length !== 2 ||
        !selectedDates[0] ||
        !selectedDates[1] ||
        selectedDates[0].toDateString() === selectedDates[1].toDateString()

      ) {
        alert('Please select a valid date range.');
        return;
      }
      console.log("selected dates", selectedDates);
    } else {
      if (!selectedDate) {
        alert('Please select a date.');
        return;
      }
    }

    fetchReport();
  };

  return (
    <div className="calendar-container">
      <h2>{title}</h2>
      <div className="pickers-container">
        <Select
          options={reportType}
          value={selectedReport}
          onChange={(opt) => {
            setSelectedReport(opt);
            setSelectedDate(null);
            setSelectedDates(null);
          }}
        />
      </div>

      <div style={{ display: "flex", margin: "10px 0" }}>
        <FaInfoCircle />
        <span style={{ marginLeft: 5 }}>{getReportInfoMessage()}</span>
      </div>

      <Calendar
        onChange={(val) => {
          if (selectedReport.value === "customize") {
            // Prevent same date range
            if (val[0].toDateString() === val[1].toDateString()) {
              setSelectedDates(null);
              return;
            }
            setSelectedDates(val);
          } else {
            setSelectedDate(val);
          }
        }}
        onClickDay={(value) => {
          if (selectedReport.value === "customize") {
            // Clear old selection when user starts fresh
            setSelectedDates(null);
          }
        }}
        selectRange={selectedReport.value === "customize"}
        value={selectedReport.value === "customize"
          ? selectedDates || null
          : selectedDate || null
        }
        minDate={minDate}
        maxDate={maxDate}
        defaultActiveStartDate={maxDate}
        tileDisabled={tileDisabled}
        showNeighboringMonth={false}
      />

      <button onClick={checkForDateandReportType} disabled={loading}>      
        {loading ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
              <ClipLoader size={20} color={"#0f0101"} loading={loading} />
              <span style={{ marginLeft: '10px' }}>Downloading...</span>
          </div>
          ) : (
            'Download Report'
          )}
      </button>
    </div>
  );
};

export default ConsumptionReport;